$bog_slop $mol_page
	title \Слопометр
	attr *
		^
		bog_slop_popup <= popup false
	tools /
		<= Switch $mol_check_box
			title \С моделью
			checked? <=> llm_on? false
	body /
		<= Input $mol_textarea
			hint \Вставь текст — можно прямо с Markdown-разметкой
			value? <=> text? \
		<= Setup $mol_view
			sub <= setup /
		<= Report $mol_view
			sub <= report /
	Model $mol_select
		hint \Модель
		dictionary <= model_dict *
		value? <=> llm_model? \
	Key $mol_string
		hint \Ключ OpenRouter — sk-or-v1-…
		type \password
		value? <=> llm_key? \
	Keys_link $mol_link
		uri \https://openrouter.ai/keys
		target \_blank
		title \Взять ключ
	Empty $mol_view
		sub /
			<= empty_hint \Индекс считается сам, пока печатаешь. Кнопки нет.
	Verdict $bog_slop_verdict
		tier <= tier \human
		index <= index_label \
		label <= tier_label \
		note <= paras_label \
	Metrics $mol_view
		sub <= metric_rows /
	Status $mol_view
		attr *
			^
			bog_slop_state <= status_kind \
		sub <= status /
	Note $mol_view
		sub /
			<= note \
	Metric* $bog_slop_bar
		title <= metric_title* \
		value <= metric_value* \
		portion <= metric_portion* 0

$bog_slop_verdict $mol_view
	tier \human
	index \
	label \
	note \
	attr *
		^
		bog_slop_tier <= tier
	sub /
		<= Index $mol_view
			sub / <= index
		<= Side $mol_view
			sub /
				<= Label $mol_view
					sub / <= label
				<= Note $mol_view
					sub / <= note

$bog_slop_bar $mol_view
	title \
	value \
	portion 0
	sub /
		<= Head $mol_view
			sub /
				<= Title $mol_view
					sub / <= title
				<= Value $mol_view
					sub / <= value
		<= Bar $mol_portion
			portion <= portion 0
